/* eslint-disable indent */
import styled, { css } from 'react-emotion';
import { translate } from 'react-i18next';
import withDirection from '~/modules/core/utils/mediaHelpers/withDirection';

const AccordionMainList = withDirection(styled.div`
  .ui.accordion {
    &:not(.styled) {
      .accordion .title ~ .content:not(.ui) {
        /* Box */
        padding: 0;
      }
    }
    .accordion {
      /* Box */
      margin: 0;
    }
  }
  .accordion.ui {
    /* Box */
    padding: 0 ${props => props.theme.paddings.large}px;
    border: ${props => props.theme.borders.size.thin}px solid
      ${props => props.theme.borders.color.light};
    border-radius: ${props => props.theme.borders.radius.normal}px;
    .title {
      /* Positioning */
      position: relative;
      /* Box */
      border-top: ${props => props.theme.borders.size.thin}px solid
        ${props => props.theme.borders.color.light};
      padding: ${props => 1.5 * props.theme.new.spacer}px 0;
      /* Text */
      font-size: ${props => props.theme.fonts.sizes.medium}px;
      text-transform: capitalize;
      font-weight: ${props => props.theme.fonts.weights.semiBold};
      :first-child {
        /* Box */
        border: none;
      }
      :before {
        /* Positioning */
        position: absolute;
        ${props => (props.direction === 'rtl'
            ? css`
                left: 3px;
              `
            : css`
                right: 3px;
              `)}
        top: 15px;
        /* Text */
        font-family: fontello, sans-serif;
        font-size: ${props => props.theme.fonts.sizes.xxSmall}px;
        /* Color */
        color: ${props => props.theme.colors.labels.subtle};
        /* Other */
        content: '\\e811';
      }
      .dropdown.icon {
        ${props => (props.direction === 'rtl'
            ? css`
                float: left;
              `
            : css`
                float: right;
              `)} visibility: hidden;
      }
    }
    .title.active:before {
      /* Other */
      content: '\\e813';
    }
    .content.active {
      /* Box */
      overflow-y: auto;
      overflow-x: hidden;
      padding-bottom: ${props => props.theme.paddings.xxxLarge};
      padding-top: 0;
    }
    .content .title {
      i {
        /* Display */
        display: none;
      }
      :after {
        /* Other */
        content: initial;
      }
    }
  }
`);

export default translate('ecommerceCoreUI')(AccordionMainList);
